/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import TableStatus from './TableStatus';

/**
 * The TableInTableList model module.
 * @module model/TableInTableList
 * @version 2.8.0
 */
class TableInTableList {
    /**
     * Constructs a new <code>TableInTableList</code>.
     * @alias module:model/TableInTableList
     * @param id {String} 
     * @param name {String} 
     * @param path {String} 
     * @param status {module:model/TableStatus} 
     * @param creationDate {String} 
     * @param lastModificationDate {String} 
     * @param isTableFileStillExisting {Boolean} 
     */
    constructor(id, name, path, status, creationDate, lastModificationDate, isTableFileStillExisting) { 
        
        TableInTableList.initialize(this, id, name, path, status, creationDate, lastModificationDate, isTableFileStillExisting);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name, path, status, creationDate, lastModificationDate, isTableFileStillExisting) { 
        obj['id'] = id;
        obj['name'] = name;
        obj['path'] = path;
        obj['status'] = status;
        obj['creationDate'] = creationDate;
        obj['lastModificationDate'] = lastModificationDate;
        obj['isTableFileStillExisting'] = isTableFileStillExisting;
    }

    /**
     * Constructs a <code>TableInTableList</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TableInTableList} obj Optional instance to populate.
     * @return {module:model/TableInTableList} The populated <code>TableInTableList</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TableInTableList();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('path')) {
                obj['path'] = ApiClient.convertToType(data['path'], 'String');
            }
            if (data.hasOwnProperty('projectCollection')) {
                obj['projectCollection'] = ApiClient.convertToType(data['projectCollection'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = TableStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('creationDate')) {
                obj['creationDate'] = ApiClient.convertToType(data['creationDate'], 'String');
            }
            if (data.hasOwnProperty('lastModificationDate')) {
                obj['lastModificationDate'] = ApiClient.convertToType(data['lastModificationDate'], 'String');
            }
            if (data.hasOwnProperty('isTableFileStillExisting')) {
                obj['isTableFileStillExisting'] = ApiClient.convertToType(data['isTableFileStillExisting'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {String} id
 */
TableInTableList.prototype['id'] = undefined;

/**
 * @member {String} name
 */
TableInTableList.prototype['name'] = undefined;

/**
 * @member {String} path
 */
TableInTableList.prototype['path'] = undefined;

/**
 * @member {String} projectCollection
 */
TableInTableList.prototype['projectCollection'] = undefined;

/**
 * @member {module:model/TableStatus} status
 */
TableInTableList.prototype['status'] = undefined;

/**
 * @member {String} creationDate
 */
TableInTableList.prototype['creationDate'] = undefined;

/**
 * @member {String} lastModificationDate
 */
TableInTableList.prototype['lastModificationDate'] = undefined;

/**
 * @member {Boolean} isTableFileStillExisting
 */
TableInTableList.prototype['isTableFileStillExisting'] = undefined;






export default TableInTableList;

